import React from 'react';

// Types
import { InsightType } from 'Shared/types/Capture.types';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';

// Utils
import { getNormalizedInsight } from '../SurfaceAI.utils';

// Styles
import './SurfaceItemInsight.scss';

type Props = {
  surfaceItem;
};

const SurfaceItemInsight = ({ surfaceItem }: Props) => {
  const baseClassName = 'SurfaceItemInsight';

  const getInnerLabel = text => {
    if (surfaceItem.suggestion) {
      const suggestion_explanation = {
        active_users_high_jaccard_score: 'Members of this workspace worked alot on this document',
        workspace_users_high_collaboration_score: 'Members of this workspace collaborated alot on this document',
        user_item_is_blocked: 'You are assigned to this issue.',
        user_item_is_assigned: 'You are assigned to this issue.',
        report_item_is_blocked: 'Your teammate is assigned to this issue.',
        user_high_creation_score: "You've done alot of work on this document",
        report_high_creation_score: 'Your teammate did alot of work on this document',
        user_item_has_high_importance: 'This deal looks important',
        report_item_has_high_importance: 'This deal owned by your teammate looks important',
        user_item_was_lost: 'Discuss why this deal was lost and how to improve.',
        report_item_was_lost: "Discuss why your teammate's deal was lost and how to improve.",
      }[surfaceItem.suggestion.scenario];
      return <b title={suggestion_explanation}>{text}</b>;
    }

    return <>{text}</>;
  };

  const getLabel = () => {
    const insight = getNormalizedInsight({ surfaceItem });

    if (insight === InsightType.BLOCKED) {
      return (
        <>
          <WpIcon name="minus-octagon" />
          <span className={`${baseClassName}__label`}>{getInnerLabel('Blocked')}</span>
        </>
      );
    } else if (insight === InsightType.ACTIVE) {
      return (
        <>
          <WpIcon name="bolt" />
          <span className={`${baseClassName}__label`}>{getInnerLabel('Active')}</span>
        </>
      );
    } else if (insight === InsightType.NEW) {
      return (
        <>
          <WpIcon name="bell" />
          <span className={`${baseClassName}__label`}>{getInnerLabel('New')}</span>
        </>
      );
    }
  };

  return <div className={baseClassName}>{getLabel()}</div>;
};

export default SurfaceItemInsight;
